import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { ClickableContainer } from 'components/clickable-container';
import IconCircleCheck from 'components/icons/circle-check';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { UIPattern } from 'state/offers/types';

export const CARD_WIDTH = '341px';

/**
 * LockedOffersCardView
 */
export const Container = styled.div`
  border-radius: 0.3rem;
  box-shadow: ${Styles.boxShadow};
  width: ${CARD_WIDTH};
  min-width: ${CARD_WIDTH};
  transition: 0.1s;
  height: 100%;

  &:hover {
    box-shadow: 0px 0px 0px 3px ${Styles.color.grey.four};
  }
`;
export const BackgroundImageContainer = styled(Picture)``;

/**
 * LockedCard
 */
export const CardContainer = styled(ClickableContainer)<{ centerVertical?: boolean }>`
  position: relative;
  padding: 0.6rem 1rem 0.8rem 1rem;
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: ${({ centerVertical }) => (centerVertical ? 'center' : 'space-between')};
`;

export const Header = styled(SanityBlockRenderer)`
  p {
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.base};
    font-weight: ${Styles.fontWeight.heavy};
    font-size: 1.55rem;
    line-height: 1.5rem;
  }
`;

export const ErrorText = styled.div`
  text-align: center;
  padding: 1rem 0;
`;

export const ErrorControlsContainer = styled.div`
  display: flex;
  padding: 0.75rem 0;
  justify-content: center;
`;

export const SubheaderContainer = styled.div<{ mode: string }>`
  width: ${({ mode }) => (mode === UIPattern.LIST || mode === UIPattern.ERROR ? '100%;' : '70%;')};
`;

export const Subheader = styled(SanityBlockRenderer)`
  p {
    color: ${Styles.color.black};
    font-size: 0.84rem;
    font-weight: ${Styles.fontWeight.heavy};
    line-height: 1.25;
    margin-top: 0.5rem;
  }
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  display: flex;
  max-width: 100%;
`;

export const Countdown = styled.div`
  display: flex;
  flex: 0.8;
  font-size: 0.6rem;
  padding: 0;
  align-items: center;
`;

export const StyledActionButton = styled(ActionButton)`
  padding: 0 1rem;
`;

/**
 * OfferStepper
 */
export const Circle = styled(IconCircleCheck)`
  width: 1.5rem;
  fill: ${Styles.color.primary};
`;
export const CircleDot = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 15rem;
  border: 0.57rem solid ${Styles.color.grey.four};
  display: block;
  background-color: ${Styles.color.white};
`;

export const Stepper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;
`;
export const Checkpoint = styled.div`
  z-index: ${Styles.zIndex.normal};
`;
export const CheckpointDetail = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Label = styled.span`
  padding: 0.55rem;
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 0.7rem;
`;

export const Segment = styled.span<{ totalSteps: number; percentComplete: number }>`
  width: ${props => `calc(100% / ${props.totalSteps})`};
  max-width: 10%;
  height: 0.2rem;
  margin-top: auto;
  margin-bottom: 11px;
  background: ${props => {
    return `linear-gradient(
        to right,
        ${Styles.color.primary} 0 ${props.percentComplete}%,
        ${Styles.color.grey.four} ${props.percentComplete}% 100%
      );`;
  }};
`;

/**
 * OfferList
 */
export const List = styled.div`
  padding: 0.5rem;
`;

export const PictureIcon = styled(Picture)`
  padding: 0.1rem;
  margin-left: 0.4rem;
  width: 30px;
  height: 30px;
`;

export const ItemDetail = styled.div<{ isComplete: boolean }>`
  display: flex;
  align-items: center;
  color: ${props => (props.isComplete ? Styles.color.primary : Styles.color.secondary)};
`;
export const ProductLabel = styled.span`
  padding: 0.25rem 0.4rem;
  font-size: 0.9rem;
`;
